"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeedbackNotificationSlots = exports.default = exports.FeedbackNotification = void 0;
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _useAutoclose = _interopRequireDefault(require("../useAutoclose"));
var _utils = require("../utils");
var _feedbackNotificationClasses = require("./feedbackNotificationClasses");
var _jsxRuntime = require("react/jsx-runtime");
const getFeedbackNotificationSlots = ownerState => {
  const {
    color
  } = ownerState;
  return {
    root: ['root', `color${(0, _utils.capitalize)(color)}`],
    notification: ['notification'],
    icon: ['icon'],
    message: ['message']
  };
};
exports.getFeedbackNotificationSlots = getFeedbackNotificationSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getFeedbackNotificationSlots(ownerState);
  const composedClasses = (0, _base.unstable_composeClasses)(slots, _feedbackNotificationClasses.getFeedbackNotificationUtilityClass, classes);
  return {
    ...classes,
    ...composedClasses
  };
};
const FeedbackNotificationRoot = (0, _material.styled)('div', {
  name: 'MuiOriFeedbackNotification',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.root, styles[`color${(0, _utils.capitalize)(ownerState.color)}`]],
  shouldForwardProp: prop => (0, _utils.rootShouldForwardProp)(prop)
})(({
  theme,
  ownerState
}) => ({
  position: 'fixed',
  zIndex: theme.zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  outline: 0,
  ...(ownerState.keepMounted && !ownerState.open && {
    visibility: 'hidden'
  })
}));
const FeedbackNotificationBackdrop = (0, _material.styled)(_material.Backdrop, {
  name: 'MuiOriFeedbackNotification',
  slot: 'Backdrop',
  overridesResolver: (_, styles) => [styles.backdrop]
})({
  zIndex: -1
});
const Notification = (0, _material.styled)('div', {
  name: 'MuiOriFeedbackNotification',
  slot: 'Notification',
  skipSx: true,
  overridesResolver: (_, styles) => [styles.notification]
})(({
  theme,
  ownerState
}) => ({
  display: 'flex',
  backdropFilter: 'blur(2px)',
  outline: 0,
  flexDirection: 'row',
  justifyItems: 'center',
  alignItems: 'flex-start',
  columnGap: theme.spacing(2),
  padding: theme.spacing(3),
  minHeight: 'unset',
  borderRadius: theme.shape.largeComponentRadius,
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(6)
  },
  ...(ownerState.color === 'error' && {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText
  }),
  ...(ownerState.color === 'success' && {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.text.primary
  }),
  ...(ownerState.color === 'warning' && {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.warning.contrastText
  }),
  ...(ownerState.color === 'initial' && {
    backgroundColor: theme.palette.default.main,
    color: theme.palette.default.contrastText
  })
}));
const Message = (0, _material.styled)('div', {
  name: 'MuiOriFeedbackNotification',
  slot: 'Message',
  skipSx: true,
  overridesResolver: (_, styles) => [styles.message]
})(({
  theme,
  ownerState
}) => ({
  fontSize: theme.typography.body1.fontSize,
  fontWeight: 'bold',
  alignSelf: 'center',
  order: 2,
  display: 'flex',
  alignItems: 'flex-start',
  maxWidth: 250,
  '&>p': {
    fontSize: 'inherit',
    fontWeight: 'inherit'
  },
  [theme.breakpoints.up('md')]: {
    maxWidth: 350
  }
}));
const IconRoot = (0, _material.styled)('div', {
  name: 'MuiOriFeedbackNotification',
  slot: 'Icon',
  skipSx: true,
  overridesResolver: (_, styles) => [styles.icon]
})(({
  theme,
  ownerState
}) => ({
  fontSize: '3rem',
  lineHeight: 1,
  '&>svg': {
    fontSize: 'inherit'
  }
}));
const FeedbackNotification = exports.FeedbackNotification = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _material.useThemeProps)({
    props: inProps,
    name: 'MuiOriFeedbackNotification'
  });
  const {
    ariaDescribedby,
    ariaLabelledby,
    ariaModal = true,
    children,
    className,
    closeAfterTransition = true,
    color = 'initial',
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableEscapeKeyDown = false,
    disablePortal = true,
    disableRestoreFocus = false,
    disableScrollLock = true,
    hideBackdrop = true,
    keepMounted = false,
    icon,
    open,
    onClose,
    timeoutMs = 2000,
    ...other
  } = props;
  const commonProps = {
    closeAfterTransition,
    disableAutoFocus,
    disableEnforceFocus,
    disableEscapeKeyDown,
    disablePortal,
    disableRestoreFocus,
    disableScrollLock,
    hideBackdrop,
    keepMounted
  };
  const ownerState = (0, _react.useMemo)(() => ({
    ...props,
    color
  }), [color, props]);
  const classes = useUtilityClasses(ownerState);
  const handleClose = (0, _react.useCallback)(() => {
    onClose?.({}, 'backdropClick');
  }, [onClose]);
  (0, _useAutoclose.default)({
    onClose: handleClose,
    open,
    timeoutMs,
    autoClose: true
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Modal, {
    slots: {
      root: FeedbackNotificationRoot,
      backdrop: FeedbackNotificationBackdrop
    },
    slotProps: {
      root: () => ({
        ownerState
      })
    },
    open: open,
    className: (0, _clsx.default)(classes.root, className),
    ...other,
    ref: ref,
    ...commonProps,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Notification, {
      className: classes.notification,
      ownerState: ownerState,
      "aria-describedby": ariaDescribedby,
      "aria-labelledby": ariaLabelledby,
      "aria-modal": ariaModal,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(IconRoot, {
        ownerState: ownerState,
        className: classes.icon,
        children: icon
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Message, {
        ownerState: ownerState,
        className: classes.message,
        children: children
      })]
    })
  });
});
var _default = exports.default = FeedbackNotification;
//# sourceMappingURL=FeedbackNotification.js.map